import Axios from "helpers/Interceptor"
import { SoundcloudArtistProfile } from "modules/Types"

/**
 * Searches for artists on SoundCloud based on a query string
 * @param query - Search term to find SoundCloud artists
 * @returns Promise containing the artist search results data
 * @throws Error if the API request fails
 */
export const fetchSoundCloudArtists_api = async (query: string): Promise<SoundcloudArtistProfile[]> => {
    try {
        const results = await Axios.get<SoundcloudArtistProfile[]>(`/soundcloud/search/artists`, {
            params: {
                q: query
            }
        })

        return results.data
    } catch (error: any) {
        throw error
    }
}
